<osp-notification-overlay-toggler
  (onClick)="overlayPanel.toggle($event)"
  [icon]="IconKey.TopbarAutomatedTransferIndicator | icon"
  [amount]="notificationsTotalAmount$ | async"
/>

<osp-overlay-panel #op [showFooter]="false">
  <div class="w-full flex align-items-center justify-content-between" header>
    <h3>{{ 'modules.navigation.topbar.automatedTransfersNotifications' | translate }}</h3>
    @if (((notificationsTotalAmount$ | async) ?? 0) > 0) {
      <osp-acknowledge-all-button
        [acknowledgeCb]="acknowledgeAll.bind(this)"
        [loading]="$isLoadingAcknowledgeAll()"
        [disabled]="$isLoadingAcknowledge()"
      />
    }
  </div>

  <div body>
    @if (notificationsTotalAmount$ | async) {
      @for (notification of notifications$ | async; track notification?.notificationId) {
        <osp-overlay-notification>
          <div class="notification__left-column" (click)="onItemClick(notification?.redirectCb)">
            <osp-notification-severity-ball
              [severity]="notification?.notificationType | automatedTransferNotificationTypeToBallSeverity"
            />
            <div class="notification__info">
              <p class="text-overflow text-sm text-color font-bold">
                {{ notification?.title || '' }}
              </p>
              <p class="mt-2 text-xs text-color-secondary notification__info-body">{{ notification?.body || '' }}</p>
            </div>
          </div>
          <div class="notification__right-column">
            <osp-acknowledge-notification-button (onClick)="acknowledge(notification?.notificationId)" />
          </div>
        </osp-overlay-notification>
      }
    } @else {
      <osp-no-notification-found [isError]="$isNotificationsError()" />
    }
  </div>
</osp-overlay-panel>
